<template>
<div>
    <div class="field-label" v-if="showFieldLabel">{{provider.landing_service_label || $t('provider.service')}}</div>
    <ding-select
        v-model="internalValue"
        :options="options"
        :placeholder="provider.landing_service_label ? $t('message.select_custom', {custom: provider.landing_service_label}) : $t('message.choose_service')"
        :preselectFirst="preselectFirst"
        :disabled="options.length === 0"
        ref="select"
        :force-option-container-style="optionContainerStyle"
        value-attribute="id"
        label-attribute="title">
        <template slot="option-container-header">
            <div class="option-container-header-wrapper">
                <div class="option-container-header">
                    {{ $t(provider.landing_service_label ? 'message.please_select_service_to_start_custom' : 'message.please_select_service_to_start', { custom: provider.landing_service_label}) }}
                </div>
                <div class="popup-gray-close-button" @click="closeOptions">
                    <img src="/img/close_cross@2x.png" />
                </div>
            </div>
        </template>
        <template slot="option" slot-scope="scope">
            <div class="time-check-option hover-border-theme-tinted">
                <div class="option-text">{{scope.option.title}}</div> 
                <div class="option-service-attribute">{{scope.option.price}}</div> 
                <div class="text-left">
                    <span class="badge badge-secondary" v-if="!scope.option.hide_duration">
                        {{ 
                            $t('services.duration') + ' ' +
                            getDurationTextForMinutes(scope.option.duration_minutes)
                        }}
                    </span>
                    <span v-if="scope.option.limited_periods && !scope.option.hide_limited_periods" class="badge badge-secondary">
                        <div v-for="p in scope.option.limited_periods" :key="p.id">
                            {{$t('services.limited_period', {start: providerTimezoneDateOnly(p.start), end: providerTimezoneDateOnly(p.end)})}}
                        </div>
                    </span> 
                    <span v-if="scope.option.start_time && !scope.option.hide_start_time" class="badge badge-secondary">{{$t('services.fixed_start_time_at', {start: scope.option.start_time})}}</span> 
                </div>
                <div class="option-description">{{scope.option.description}}</div> 
            </div>
        </template>
    </ding-select>
</div>
  
</template>

<script>
import Chip from '../common/Chip'
import dingSelect from '../common/Select';
import moment from 'moment';

export default {
    components: {dingSelect, Chip},
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            required: false
        },
        showFieldLabel: {
            type: Boolean,
            required: true
        },
        provider: {
            type: Object,
            required: true
        },
        preselectFirst: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        optionContainerStyle() {
            return {
                top: '0',
                right: '0',
                bottom: '0',
                left: '0',
                padding: '32px 8px 32px',
                background: '#FFFFFF60',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                animation: 'fade 0.2s',
                borderRadius: '0px !important',
                backdropFilter: 'blur(20px)',
            };
        }
    },
    watch: {
        internalValue() {
            if (this.internalValue !== this.value) {
                this.$emit('input', this.internalValue);
            }
        },
        value() {
            this.internalValue = this.value;
        }
    },
    data() {
        return {
            internalValue: this.value
        };
    },
    methods: {
        closeOptions() {
            this.$refs.select.close();
        },
        open() {
            this.$refs.select.open();
        },
        providerTimezoneDateOnly(dateString) {
            return moment.tz(dateString, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD')
        },
        getDurationTextForMinutes(minutes) {
            var hours = Math.floor(minutes / 60);
            var minutes = minutes % 60;

            var result = '';
            if (hours > 0) {
                var key = hours > 1 ? 'hours' : 'hour';
                result += (hours + ' ' + this.$t('services.' + key));
            }
            if (minutes > 0) {
                var key = minutes > 1 ? 'minutes' : 'minute';
                result += (minutes + ' ' + this.$t('services.' + key));
            }
            return result;
        },
    }

}
</script>

<style scoped lang="scss">

.time-check-option {
    box-shadow: 0 0 12px #AAA;
    background-color: white;
    padding: 16px 12px;
    overflow: hidden;
    max-width: 480px;
    box-sizing: border-box;
    border-left: 12px solid white;
    border-radius: 12px;
    margin-bottom: 4px;
    transition: all .3s;

    min-width: 480px;
    @media (max-width: 520px) {
        min-width: calc(100vw - 48px);
    }

    &:hover {
        background: rgba(255, 255, 255, 0.94) !important;
    }

    .option-text {
        font-weight: bold;
        font-size: 1.2rem;
        color: #444;
        text-align: left;
    }

    .option-description {
        white-space: pre-line;
        user-select: none;
        font-size: 0.9rem;
        line-height: 1.55;
        margin: 8px 0 8px;
        padding-right: 8px;
        color: #666;
        text-align: left;
    }

    .option-service-attribute {
        font-size: 0.9rem;
        color: #444;
        text-align: left;
    }
        
}

.option-container-header-wrapper {
    margin-bottom: .75rem;
    gap: 16px;
    display: flex;
    justify-content: space-between;

    min-width: 480px;
    @media (max-width: 520px) {
        min-width: calc(100vw - 48px);
    }
}

.option-container-header {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.25rem;
    text-align: center;
    color: #444;
}

</style>